import { render, staticRenderFns } from "./GameItems.vue?vue&type=template&id=42114f0e&scoped=true&"
import script from "./GameItems.vue?vue&type=script&lang=js&"
export * from "./GameItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42114f0e",
  null
  
)

export default component.exports